import { ErrorType } from "../../models/HttpError";

export interface ProtocolVisitsState {
    isLoading: boolean;
    isGeneratedSuccessfully: boolean;
    failOnGenerating: boolean;
    error: ErrorType | null;

    excelBlob: Blob | null;
}

export const ProtocolVisitsUnloadState: ProtocolVisitsState = {
    isLoading: false,
    isGeneratedSuccessfully: false,
    failOnGenerating: false,
    error: null,
    excelBlob: null
};
